import { render, staticRenderFns } from "./pkiManage.vue?vue&type=template&id=b1227dcc&"
import script from "./pkiManage.vue?vue&type=script&lang=js&"
export * from "./pkiManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports